import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import Select from "react-select";
import Swal from "sweetalert2";
import "react-loading-skeleton/dist/skeleton.css";
import KartuUjianPDF from './KartuKodeUjina.js';
import { PDFDownloadLink } from "@react-pdf/renderer";
import { useAuth } from '../../context/AuthContext.js';

const JadwalUjian = () => {
    const navigate = useNavigate();
     const { user, loading, logout } = useAuth();
    const hari = [
        { value: 'Senin', label: 'Senin' },
        { value: 'Selasa', label: 'Selesa' },
        { value: 'Rabu', label: 'Rabu' },
        { value: 'Kamis', label: 'Kamis' },
        { value: 'Jumat', label: 'Jumat' },
        { value: 'Sabtu', label: 'Sabtu' },
        { value: 'Minggu', label: 'Minggu' }
      ];
      const [formData, setFormData] = useState({
        hari: hari[0].value,
        tgl: "",
        sesi: "1",
        data_id: "",
        nama_guru: "",
        durasi: 120,
        data: []
    });
    const [customTrigger, setCustomTrigger] = useState(0);

    const [getUjian, setUjian] = useState([]); // State untuk menyimpan daftar kelas
    const [dataGuru, setGuru] = useState([]); // State untuk menyimpan daftar kelas
    const [dataMstU, setDataMstU] = useState([]);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState("Hari ini"); // Default: "Hari ini"

    const [dari, setDari] = useState("");
    const [sampai, setSampai] = useState("");


    const [isEditing, setIsEditing] = useState(false);
    const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun
    const [plhjadwal, setPlhJadwal] = useState([]); // State untuk menyimpan informasi akun
    const [npsn, setNpsn] = useState("");
    const [refrashaktif, setRefrashaktif] = useState(true);

    const plhjadwalRef = useRef([]);
     const [ujianData, setUjianData] = useState([]);

    const formatTanggal = (date) => {
        return new Intl.DateTimeFormat('id-ID', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'Asia/Jakarta', // Pastikan menggunakan zona waktu lokal
        })
            .format(date)
            .split('/').reverse().join('-'); // Format ke yyyy-MM-dd
    };

    
    const getDataRefrensi = useCallback(async () => {


       try {
                // Kirim request ke server dengan header level user
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/getRefToJadwal`, {
                    method: 'GET',
                    headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch kelas");
                }

                const data = await response.json();
                setGuru(data.pengawas);
                setDataMstU(data.mstujian)
            } catch (error) {
                 Swal.fire("Error!", error.message || 'Something went wrong', "error");
            }
    }, []);



    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            console.error("Token required");
            return; // Jika tidak ada token, hentikan eksekusi
        }

        try {
            // Decode payload dari token JWT
            const decoded = jwtDecode(authToken);
            setInformasiAkun(decoded); 
        } catch (error) {
            console.error("Invalid token:", error);
            navigate('/login'); // Jika token tidak valid, arahkan ke halaman login
            return;
        }


    }, []);
   
    useEffect(() => {
  getDataRefrensi();

  const fetchData = async () => {
    

    if ($.fn.dataTable.isDataTable(".table")) {
      $(".table").DataTable().destroy();
    }

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);

    const todayStr = formatTanggal(today);
    const tomorrowStr = formatTanggal(tomorrow);
    const nextWeekStr = formatTanggal(nextWeek);

    let q = query(
      collection(db, "jadwal"),
      where("npsn", "==", user.npsn),
      orderBy("tgl", "desc")
    );

    if (filter === "Hari ini") {
      q = query(q, where("tgl", "==", todayStr));
    } else if (filter === "Besok") {
      q = query(q, where("tgl", "==", tomorrowStr));
    } else if (filter === "1 Minggu") {
      q = query(q, where("tgl", ">=", todayStr), where("tgl", "<=", nextWeekStr));
    } else if (filter === "Custom") {
      // Panggil function async untuk ambil tanggal dari Swal
      const result = await Swal.fire({
        title: 'Pilih Rentang Tanggal',
        html:
          `<label>Dari Tanggal:</label><br>
          <input type="date" id="tglDari"  class="swal2-input"><br>
          <label>Sampai Tanggal:</label><br>
          <input type="date" id="tglSampai"  class="swal2-input">`,
        focusConfirm: false,
        confirmButtonText: 'Cari',
        showCancelButton: true,
        preConfirm: () => {
          const dari = document.getElementById('tglDari').value;
          const sampai = document.getElementById('tglSampai').value;

          if (!dari || !sampai) {
            Swal.showValidationMessage('Kedua tanggal harus diisi');
          } else if (dari > sampai) {
            Swal.showValidationMessage('Tanggal "Dari" tidak boleh lebih besar dari "Sampai"');
          }

          return { dari, sampai };
        }
      });

      if (!result.isConfirmed) return; // Kalau user cancel, jangan lanjut

      const { dari, sampai } = result.value;
      setDari(dari)
      setSampai(sampai)
      q = query(q, where("tgl", ">=", dari), where("tgl", "<=", sampai));
    }

    setRefrashaktif(false);

    try {
      const ujianSnap = await getDocs(q);
      const ujianData2 = ujianSnap.docs.map((doc) => ({
        ...doc.data(),
      }));

      setUjianData(ujianData2);

      $(".table").DataTable({
        data: ujianData2,
        drawCallback: function () {
          const selected = plhjadwalRef.current.map(item => item.kode);
          $(".row-checkbox").each(function () {
            const id = $(this).data("id");
            if (selected.includes(id)) {
              $(this).prop("checked", true);
            }
          });

          const table = $(".table").DataTable();
          const currentPageData = table.rows({ page: 'current' }).data().toArray();
          const allChecked = currentPageData.every(row => selected.includes(row.kode));
          $("#select-all-checkbox").prop("checked", allChecked);
        },
          columns: [
                        {
                            data: null,
                            orderable: false,
                            className: "select-checkbox",
                            render: (data, type, row, meta) =>
                                `<input type="checkbox" class="row-checkbox" data-id='${row.kode}' data-row='${JSON.stringify(row)}' />`,
                        },
                         {
                            data: null,
                            orderable: false,
                            className: "select-checkbox",
                            render: (data, type, row, meta) =>
                                `${meta.row + 1}`,
                        },
                        {
                            data: null,
                            render: (data) => {
                                let mapelList = [];
                              if (Array.isArray(data?.data)) {
    mapelList = data.data.map((item) => {
        const jumlahSoal = Array.isArray(item.soal) ? item.soal.length : 0;
        return `${item.nama_mapel} [${item.nama_rombel}] (${jumlahSoal})`;
    });
}

                                return `<b>${data.kode}</b></br>${data.ruang}</br>${mapelList.join("</br> ")}`;
                            },
                        },
                        { data: null, render: (data) => `<b>${data.sesi}</b>` },
                       
                        {
                            data: null,
                            render: (data, type, row) =>
                                `${row.nama_guru || row.nama_pengawas || dataGuru.find((option) => option.data_id === row.data_id)?.nama || "-"}`,
                        },
                        {
                            data: null,
                            render: (data, type, row) =>
                                `
                                   <div class="btn-group">
  <button 
    class="btn btn-light btn-sm dropdown-toggle" 
    type="button" 
    data-bs-toggle="dropdown" 
    aria-expanded="false"
    style="border: none;">
    <i class="ti ti-dots-vertical"></i>
  </button>
  <ul class="dropdown-menu dropdown-menu-end">
    <li>
       <a  class="dropdown-item edit-btn"  href="/admin/refrensi/pelaksanaanujian?id=${row.kode}" title="Pelaksanaan Ujian">
                                    <i class="ti ti-device-desktop f-20" ></i> Mulai
                                </a>
    </li>
    <li>
      <a href="#"  data-bs-toggle="modal" data-bs-target="#ujianModal" class="dropdown-item edit-btn"  data-row='${JSON.stringify(row)}' title="Ubah Data">
                                    <i class="ti ti-edit f-20"></i> Ubah
                                </a>
      
    </li>
    <li>
<a href="#"  class="dropdown-item edit-btn"  data-id="${row.kode}" title="Hapus">
                                    <i class="ti ti-trash f-20"></i> Hapus
                                </a>
    </li>
  </ul>
</div>


                                `,
                        },
                    ],
        columnDefs: [{
          targets: 0,
          title: `<input type="checkbox" id="select-all-checkbox" />`,
        }],
        destroy: true,
        dom: "<'row'<'col-9'f><'col-3'B>><'row'<'col-12'tr>><'row'<'col-10'p><'col-2'i>>",
        language: {
          search: "",
          lengthMenu: "_MENU_",
          emptyTable: "Belum memiliki data",
          loadingRecords: "Loading....",
          zeroRecords: "Belum memiliki data",
        },
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData();

  return () => {
    if ($.fn.dataTable.isDataTable(".table")) {
      $(".table").DataTable().destroy();
    }
  };
}, [filter, refrashaktif,customTrigger]);


    
    $(document).on("change", "#select-all-checkbox", function () {
        const table = $(".table").DataTable();
        const checked = $(this).is(":checked");
    
        const selectedRows = [];
    
        table.rows().every(function () {
            const rowData = this.data(); // ambil data dari DataTables, bukan DOM
            const rowNode = this.node();
            $(rowNode).find(".row-checkbox").prop("checked", checked); // update checkbox di semua halaman (yang muncul)
    
            if (checked) {
                selectedRows.push(rowData);
            }
        });
    
        if (checked) {
           
            setPlhJadwal(ujianData);
            plhjadwalRef.current = ujianData;
        } else {
            setPlhJadwal([]);
            plhjadwalRef.current =[]
        }
        console.log(ujianData)
        
    });
    
    // Handle tiap baris checkbox
    $(document).on("change", ".row-checkbox", function () {
        const checkedRows = [];
        $(".row-checkbox:checked").each(function () {
            const rowData = JSON.parse($(this).attr("data-row"));
            checkedRows.push(rowData);
        });
        setPlhJadwal(checkedRows);
    });

    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit(rowData);
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id");
    
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapusujian`, {
                    method: "POST",
                    headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
                    credentials: 'include',
                    body: JSON.stringify({ id_ujian : id })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                        $('.table').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                    } else {
                        Swal.fire("Gagal!", data.message, "error");
                    }
                })
                .catch(error => {
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                });
            }
        });
    });

    // Handle perubahan input form
    const handleChange = (e) => {
        const { name, value } = e.target;
        let selectedText = "";
        if (name === "kode" || name === "data_id") {
            selectedText = e.target.options[e.target.selectedIndex].text;
        }


        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            ...(name === "kode" && { nama_ujian: selectedText }),
            ...(name === "data_id" && { nama_guru: selectedText })
        }));
        console.log(formData)
    };



    // Buka modal untuk edit data
    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
    };

    // Reset form untuk tambah data baru
    const handleNew = () => {
        setIsEditing(false);

    };
    const handleSubmit = async (e) => {
        console.log(formData)
        e.preventDefault();

        // Fungsi untuk membuat kode unik
        const generateRandomCode = () =>
            (Date.now().toString(36) + Math.random().toString(36).substring(2, 3)).toUpperCase();

        let kodeid = generateRandomCode(); // Gunakan `let` karena bisa diubah nanti

        try {
        
            if (isEditing) {
                kodeid = formData.kode;
            }
            const datamapel = formData.data.map(d => ({
                ...d,
                soal: Array.isArray(d.soal) 
                    ? d.soal
                    : JSON.parse(d.soal || "[]")
            }));
            
            const datainf = {
                ...formData,
                data: datamapel,
                kode: kodeid,
                npsn:user.npsn
            };
            
            
            console.log(datainf)
            
            // Simpan ke Firestore
            await setDoc(doc(db, "jadwal", kodeid), datainf);
            
            // Notifikasi sukses
            Swal.fire("Berhasil!", "Jadwal berhasil disimpan!", "success");
            setFormData({
                ...formData,
              
                data_id: "",
                nama_guru: "",
                data: []
            });
            setRefrashaktif(true)

        } catch (error) {
            console.error("Terjadi kesalahan:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat menyimpan jadwal.", "error");
        }
    };


    const handleChangeSelected = (selectedOptions) => {
        if (!selectedOptions) return;
        console.log(selectedOptions)

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;


        setFormData((prevData) => ({
            ...prevData,
            data: selectedData, 
        }));

        console.log("Updated Form Data:", formData);
    };

    const handleChangePenawasg = (selectedOptions) => {
        if (!selectedOptions) return;

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;

        setFormData((prevData) => ({
            ...prevData,
            data_id: selectedData.data_id,
        }));

        console.log("Updated Form Data:", formData);
    };

    const handleChangeMstUjian = (selectedOptions) => {
        if (!selectedOptions) return;

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;

        setFormData((prevData) => ({
            ...prevData,
            kode_mst: selectedData.kode_mst_ujian, // Perbaiki agar langsung pakai `selectedData`
        }));
        console.log(selectedData.kode_mst_ujian)
        getRefrensiUjianByKode(selectedData.kode_mst_ujian)

    };
    
 const getRefrensiUjianByKode = useCallback(async (mstkode) => {


       try {
                // Kirim request ke server dengan header level user
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/getUjian?id=${mstkode}`, {
                    method: 'GET',
                     headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch kelas");
                }

                const data = await response.json();
                console.log(data)

                setUjian(data.data);
                
            } catch (error) {
                 Swal.fire("Error!", error.message || 'Something went wrong', "error");
            }
    }, []);
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setPlhJadwal(data); // Pilih semua data
        } else {
            setPlhJadwal([]); // Kosongkan jika tidak dicentang
        }
    };

    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col"><small className="text-muted">Refrensi</small><h3>Jadwal Ujian</h3></div>

                                        <div className='col-auto'>
                                            <div class="btn-group">
                                                <button type="button" class="btn btn-outline-secondary">{filter} | {dari} - {sampai}</button> 
                                                <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="sr-only">Toggle Dropdown</span></button>
                                                <div class="dropdown-menu" >
                                                    <a class="dropdown-item" href="#!" onClick={(e) =>{
                                                         const val = "Hari ini"
                                                         if (val === "Custom") {
                                                             setCustomTrigger(prev => prev + 1);
                                                            }
                                                            setFilter(val);}}>Hari ini</a> 
                                                    <a class="dropdown-item" href="#!" onClick={(e) =>{
                                                         const val = "Besok"
                                                         if (val === "Custom") {
                                                             setCustomTrigger(prev => prev + 1);
                                                            }
                                                            setFilter(val);}}>Besok</a> 
                                                    <a class="dropdown-item" href="#!" onClick={(e) =>{
                                                         const val = "1 Minggu"
                                                         if (val === "Custom") {
                                                             setCustomTrigger(prev => prev + 1);
                                                            }
                                                            setFilter(val);}}>1 Minggu</a>
                                                     <a class="dropdown-item" href="#!" onClick={(e) =>{
                                                         const val = "Semua"
                                                         if (val === "Custom") {
                                                             setCustomTrigger(prev => prev + 1);
                                                            }
                                                            setFilter(val);}}>Semua</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" href="#!" onClick={(e) =>{
                                                         const val = "Custom"
                                                         if (val === "Custom") {
                                                             setCustomTrigger(prev => prev + 1);
                                                            }
                                                            setFilter(val);}}>Custom</a>
                                                    </div>
                                                    </div>

                                            
                                        </div>
                                        <div className='col-auto'>
                                            <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Data Baru</button>
                                            {/* <button data-bs-toggle="modal" data-bs-target="#ujianModal"   type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Kirim Kode Kepada Pengawas</button> */}
                                            {plhjadwal.length > 0 ? (
                                                <PDFDownloadLink
                                                    className="btn btn-primary d-inline-flex"
                                                    document={<KartuUjianPDF data={plhjadwal} />}
                                                    fileName="kartu_ujian.pdf"
                                                >
                                                    {({ loading }) => (loading ? "Loading PDF..." : "Download Kartu")}
                                                </PDFDownloadLink>
                                            ) : (
                                                <button data-bs-toggle="modal" data-bs-target="#ujianModal" type="button" className="btn btn-primary disabled"> Download Kartu</button>

                                            )}
                                             {plhjadwal.length > 0 ? (
                                                <PDFDownloadLink
                                                    className="btn btn-primary d-inline-flex"
                                                    document={<KartuUjianPDF data={plhjadwal} />}
                                                    fileName="kartu_ujian.pdf"
                                                >
                                                    {({ loading }) => (loading ? "Loading Kirim..." : "Kirim Kode")}
                                                </PDFDownloadLink>
                                            ) : (
                                                <button data-bs-toggle="modal" data-bs-target="#ujianModal" type="button" className="btn btn-primary disabled"> Kirim Kode</button>

                                            )}
                                        </div>
                                    </div>
                                    <hr />
                                    {/* Tabel kelas */}
                                 <table className="table table-hover datatable-table">
                                        <thead>
                                            <tr>
                                                <th width="10"><input
                                                    name="jdl"
                                                    className='form-check-input'

                                                    type="checkbox"
                                                    onChange={(e) => handleSelectAll(e)}
                                                    checked={plhjadwal.length === data.length && data.length > 0}
                                                /> Semua
                                                </th>
                                                <th width="10">#</th>
                                                  <th >Detail</th>
                                                <th width="80">Hari (Sesi)</th>
                                                <th width="50">Pengawas</th>
                                                <th width="w0"><center>Action</center></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        
                                        </tbody>
                                    </table>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Input/Edit */}
            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{isEditing ? "Edit Kelas" : "Tambah Kelas"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Ruang Ujian</label>
                                <input type="text" className="form-control" name="ruang" value={formData.ruang} onChange={handleChange} required />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Tanggal Ujian</label>
                                <input type="date" className="form-control" name="tgl" value={formData.tgl} onChange={handleChange} required />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Sesi Ujian</label>
                                <input type="number" className="form-control" name="sesi" value={formData.sesi} onChange={handleChange} required />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Durasi (Menit)</label>
                                <input type="number" className="form-control" name="durasi" value={formData.durasi} onChange={(e)=>  setFormData((prevData) => ({
            ...prevData,
            durasi: parseInt(e.target.value, 10) || 120,
            
        }))} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Pengawas</label>
                                <Select
                                    options={dataGuru || []}
                                    required
                                    name="data_id"
                                    getOptionLabel={(e) => e.nama} // Menampilkan `nama` di dropdown
                                    getOptionValue={(e) => e.data_id} // Menggunakan `data_id` sebagai value
                                    value={dataGuru.find((option) => option.data_id === formData.data_id) || null}
                                    onChange={handleChangePenawasg}
                                    placeholder="Pilih Guru..."
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Master Ujian</label>
                                <Select
                                    options={dataMstU || []}
                                    required
                                    name="kode_mst"
                                    getOptionLabel={(e) => e.nama_master} // Menampilkan `nama` di dropdown
                                    getOptionValue={(e) => e.kode_mst_ujian} // Menggunakan `data_id` sebagai value
                                    value={formData.kode_mst_ujian}
                                    onChange={handleChangeMstUjian}
                                    placeholder="Pilih master Ujian..."
                                />
                            </div>

                            <div className="mb-3">
                            <label className="form-label">Ujian</label>
                            <Select
                                options={getUjian || []} // Pastikan getUjian adalah array
                                isMulti
                                name="data"
                                getOptionLabel={(e) => `${e.nama_rombel} - ${e.nama_mapel}`}
                                getOptionValue={(e) => e.id_ujian}
                                value={
                                    Array.isArray(getUjian) && Array.isArray(formData?.data)
                                        ? getUjian.filter((option) => 
                                            formData.data.some((d) => d.id_ujian?.toString() === option.id_ujian?.toString())
                                        )
                                        : []
                                }
                                
                                onChange={handleChangeSelected}
                                placeholder="Pilih Ujian..."
                            />
                        </div>


                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type="onSubmit" className="btn btn-primary"
                                data-bs-dismiss="modal"
                            >
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
    );
};

export default JadwalUjian;
